import { getItemWithExpiry } from './storage';
import { decrypteTarget } from './crypto';

/**
 * 로그인 상태 확인
 * @returns {boolean} - 로그인 여부
 */
export const isLoggedIn = () => {
  const userSession = getItemWithExpiry('userInfo');
  const sessionKey = localStorage.getItem('userSessionKey');
  
  return !!(userSession && sessionKey && userSession.isUserLogin);
};

/**
 * 현재 로그인한 사용자 정보 가져오기
 * @returns {Object|null} - 사용자 정보 또는 null
 */
export const getCurrentUser = () => {
  try {
    const userSession = getItemWithExpiry('userInfo');
    
    if (!userSession || !userSession.isUserLogin || !userSession.data) {
      return null;
    }
    
    // 암호화된 사용자 정보 복호화
    const decryptedData = decrypteTarget(userSession.data);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('사용자 정보 가져오기 실패:', error);
    return null;
  }
};

/**
 * 현재 사용자 권한 확인
 * @returns {string|null} - 사용자 권한(0: 최고관리자, 1: 계정관리자, 2: 일반사용자) 또는 null
 */
export const getUserGrade = () => {
  const user = getCurrentUser();
  return user ? user.grade : null;
};

/**
 * 현재 사용자가 관리자인지 확인
 * @returns {boolean} - 관리자 여부
 */
export const isAdmin = () => {
  const grade = getUserGrade();
  return grade === '0' || grade === '1';
};

/**
 * 현재 사용자가 최고관리자인지 확인
 * @returns {boolean} - 최고관리자 여부
 */
export const isSuperAdmin = () => {
  const grade = getUserGrade();
  return grade === '0';
}; 